import React from "react";

import { useAuth } from "./useAuth";
import { AuthContext } from "./AuthContext";

export const AuthProvider: React.FC<React.PropsWithChildren<any>> = ({ children }) => {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => React.useContext(AuthContext);
